"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Comment = void 0;

var _react = _interopRequireDefault(require("react"));

var _blocks = require("@bueno/blocks");

var _core = require("@lingui/core");

var Elements = _interopRequireWildcard(require("./Comment.styles"));

var _comments = require("../../utils/comments");

var _locale = require("../../../../context/locale");

var _dates = require("../../../../utils/dates");

var _lists = require("../../utils/lists");

var _session = require("../../../../context/session");

var _AttachmentPreview = require("./components/AttachmentPreview");

/* eslint-disable @typescript-eslint/strict-boolean-expressions */

/* eslint-disable @typescript-eslint/no-unnecessary-boolean-literal-compare */

/* eslint-disable @typescript-eslint/restrict-template-expressions */
const Comment = ({
  comment,
  onRemove
}) => {
  var _comment$author;

  const {
    data: session
  } = (0, _session.useSession)();
  const {
    locale
  } = (0, _locale.useLocale)();
  const transition = (0, _comments.formatTransition)(comment.body);
  const attachments = (0, _comments.formatAttachments)(comment.body);
  const body = (0, _comments.formatBody)(comment.body);
  const author = (_comment$author = comment.author) !== null && _comment$author !== void 0 ? _comment$author : comment.author_name_display;
  const commentDateFromNow = (0, _dates.localizedFormat)(new Date(comment.created), 'MMM d, yyyy, HH:mm', locale);
  return /*#__PURE__*/_react.default.createElement(Elements.Container, null, /*#__PURE__*/_react.default.createElement(Elements.TextArea, null, /*#__PURE__*/_react.default.createElement(Elements.Meta, null, /*#__PURE__*/_react.default.createElement(Elements.MetaText, null, commentDateFromNow, " \u2013 ", author), comment.hydraCreatedBy === (session === null || session === void 0 ? void 0 : session.authId) && /*#__PURE__*/_react.default.createElement(Elements.RemoveButton, {
    onClick: () => onRemove(comment.hydraId)
  }, _core.i18n._({
    id: 'view_action_activity.remove'
  }))), transition && /*#__PURE__*/_react.default.createElement(Elements.TransitionContainer, null, "Transitioned from \"", (0, _lists.getStatusMap)(_core.i18n)[transition.fromStatus], "\" to \"", (0, _lists.getStatusMap)(_core.i18n)[transition.toStatus], "\""), body && /*#__PURE__*/_react.default.createElement(_blocks.Markdown, {
    linkTarget: "__blank"
  }, body)), attachments.length !== 0 && /*#__PURE__*/_react.default.createElement(Elements.AttachmentList, null, attachments.map(([fileName, path]) => /*#__PURE__*/_react.default.createElement(_AttachmentPreview.AttachmentPreview, {
    key: fileName + path,
    fileName: fileName,
    path: `/api${path}`
  }))));
};

exports.Comment = Comment;